import React from 'react';
import { useIntl } from 'react-intl-next';
import { useDefaultCatch } from '@atlassian/eoc-catch';
import { useFlags } from '@atlassian/eoc-global-context';
import { ResponderNamesContainer } from '../responder-names-store';
/**
 * Wrapper should live on the root level since it uses glocal scoped container.
 */
const ResponderNamesWrapper = ({
  scope,
  isGlobal = true,
  children
}) => {
  const flagApi = useFlags();
  const intl = useIntl();
  const defaultCatch = useDefaultCatch();
  return /*#__PURE__*/React.createElement(ResponderNamesContainer, {
    flagApi: flagApi,
    intlApi: intl,
    isGlobal: isGlobal,
    scope: scope,
    defaultCatch: defaultCatch,
    displayName: "ResponderNamesWrapper"
  }, children);
};
export default ResponderNamesWrapper;